export default __webpack_public_path__ + "static/media/checkedGreen.4fd0faf5.svg";